import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { Subscription, tap } from 'rxjs';
import { ColumnEmitted, Tree } from './models/column-picker';
import { ColumnPickerItemComponent } from './components/column-picker-item/column-picker-item.component';
import { UpperCasePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MetadataService } from '../../../../../../services/metadata.service';
import { TableType } from '../../../../../../models/shipment';

@Component({
  selector: 'app-column-picker',
  standalone: true,
  templateUrl: './column-picker.component.html',
  styleUrl: './column-picker.component.scss',
  imports: [
    MatMenu,
    MatMenuItem,
    MatFormField,
    MatSelect,
    MatMenuTrigger,
    ColumnPickerItemComponent,
    UpperCasePipe,
    MatButton,
    MatError,
    ReactiveFormsModule
  ]
})
export class ColumnPickerComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() treeNodes: Tree[] = [];
  @Input() openedBy: 'dropdown' | 'button' = 'dropdown';
  @Input() preselectedColumnKey: string | null = null;
  @Input() required = false;
  @Input() allowReset = false;
  @Input() type!: TableType;
  @Output() selectedColumnKey = new EventEmitter<ColumnEmitted>();
  columnKey: string | null = null;
  columnName: string | null = null;
  fakeControl = new FormControl(null);

  private subscription = new Subscription();

  constructor(
    private cdr: ChangeDetectorRef,
    private metadataService: MetadataService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['preselectedColumnKey'] && changes['type']) {
      this.subscription.add(
        this.metadataService
          .getColumnNameBy(this.preselectedColumnKey!, this.type)
          .pipe(
            tap(name => {
              this.selectColumn(this.preselectedColumnKey!, name);
            })
          )
          .subscribe()
      );
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  selectColumn(key: string | null, name: string | null) {
    this.columnKey = key;
    this.columnName = name;
    this.selectedColumnKey.emit({ key, name });
    this.unsetError();
  }

  setError() {
    if (!this.columnKey && this.required) {
      this.fakeControl.updateValueAndValidity();
      this.fakeControl.setErrors({ required: true });
      this.fakeControl.markAsTouched();
    }
  }

  unsetError() {
    if (this.required) {
      this.fakeControl.setErrors({ required: null });
      this.fakeControl.updateValueAndValidity();
    }
  }
}
